import {
  BaseEntityDto,
  GeneralStatusMetaTypedDtoOfOperabilityStatus,
} from "@/core/api/generated/v1";

import GeneralStatusMetaDisplay, {
  GeneralStatusMetaDisplayProps,
} from "./GeneralStatusMetaDisplay";
import { OperabilityStatusDisplay } from "./Statuses/OperabilityStatusDisplay";

interface Props {
  value: GeneralStatusMetaTypedDtoOfOperabilityStatus | undefined | null;
  subjectEntity: BaseEntityDto | undefined;
  statusDisplayProps?: Partial<GeneralStatusMetaDisplayProps>;
  onMetaUpdated: (newValue: GeneralStatusMetaTypedDtoOfOperabilityStatus) => void;
}

export default function GeneralStatusMetaDisplayOfOperabilityStatus({
  value,
  subjectEntity,
  statusDisplayProps,
  onMetaUpdated,
}: Props) {
  if (!value) {
    return null;
  }

  return (
    <GeneralStatusMetaDisplay
      value={value}
      subjectEntity={subjectEntity}
      mainContent={<OperabilityStatusDisplay status={value.statusTyped} />}
      onMetaUpdated={(newValue) => {
        onMetaUpdated({ ...value, ...newValue });
      }}
      {...statusDisplayProps}
    />
  );
}
